import { Component, ViewChild, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from 'app/shared/auth/auth.service';
import { AngularFireAuth } from 'angularfire2/auth';
import { GlobalService } from 'app/shared/global.service';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { LogService } from 'app/settings/logs/shared/log.service';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html'
})

export class LoginComponent implements OnInit {

    public returnUrl: string;
    public loading = false;

    @ViewChild('form') form: NgForm;

    constructor(
        private authService: AuthService,
        private router: Router,
        private globalService: GlobalService,
        private titleService: Title,
        public angularFireAuth: AngularFireAuth,
        private route: ActivatedRoute,
        private logService: LogService,
        private translate: TranslateService) {
    }

    ngOnInit() {
        this.titleService.setTitle(this.translate.instant('login'));
        this.authService.logout();
        this.globalService.currentUser = undefined;
        // localStorage.clear();
        this.route.queryParams.subscribe(params => {
            this.returnUrl = params['returnUrl'] || '/';
        });
    }

    onSubmit() {

        this.loading = true;

        this.angularFireAuth.auth.signInWithEmailAndPassword(this.form.value.email, this.form.value.password).then((user) => {
            this.angularFireAuth.auth.currentUser.getIdToken().then((decodedToken) => {
                localStorage.setItem('token', decodedToken);
                localStorage.setItem('isLoggedIn', 'true');
                localStorage.setItem('tokenWasCreated', new Date().toString());
                localStorage.setItem('account', JSON.stringify({
                    id: decodedToken.uid,
                    name: decodedToken.name,
                    email: decodedToken.email,
                    email_verified: decodedToken.email_verified,
                }));
                this.loading = false;
                // this.globalService.showMessage('Login erfolgreich', 'Willkommen');
                this.router.navigate([this.returnUrl]);
            });
        }).catch((error) => {
            this.loading = false;
            switch(error.code) {
                case 'auth/user-not-found':
                    error.message = 'Benutzer wurde nicht gefunden. Bitte Eingaben überprüfen.';
                    break;
                case 'auth/too-many-requests':
                    error.message = 'Zu viele fehlerhafte Anmeldeversuche, bitte versuchen Sie es später noch einmal.';
                    break;
                case 'auth/internal-error':
                case 'auth/invalid-credential':
                    error.message = 'Das angegebene Login ist ungültig.';
                    break;
                case 'auth/invalid-email':
                    error.message = 'E-Mail ist nicht gültig. Bitte überprüfen.';
                    break;
                case 'auth/wrong-password':
                case 'auth/invalid-password':
                    error.message = 'Das Passwort ist nicht gültig. Bitte überprüfen.';
                    break;

            }
            console.error(error);
            this.logService.createError(this.form.value.email, error.code + ': ' + error.message).subscribe(() => {
                
            });
            this.globalService.handleError(error);
        });

        // this.form.reset();
    }
    onForgotPassword() {
        this.router.navigate(['forgotpassword'], { relativeTo: this.route.parent });
    }

    onRegister() {
        this.router.navigate(['register'], { relativeTo: this.route.parent });
    }
}



// WEBPACK FOOTER //
// ./src/app/login/login.component.ts